import { profileOfflineEnabled, offlineRuntimeEnabled } from './config';
export async function configureOfflineShell() {
  if (!('serviceWorker' in navigator)) return;
  if (profileOfflineEnabled && offlineRuntimeEnabled) {
    await navigator.serviceWorker.register('/dashboard-offline-sw.js');
  } else {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      if ([registration.active, registration.waiting, registration.installing].some(worker => worker?.scriptURL.endsWith('/dashboard-offline-sw.js'))) await registration.unregister();
    }
    // Unsynced actions and patient caches are intentionally not removed here.
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.filter(key => key.startsWith('drwaiting-dashboard-shell-')).map(key => caches.delete(key)));
    }
  }
}
